const config = {
  apiUrl: 'https://claim.oxen.io',
  useAPIEncryption: false,
  woxen: {
    txExplorerUrl: 'https://etherscan.io/tx'
  },
  oxen: {
    txExplorerUrl: 'https://session.observer/tx'
  },
  sesh: {
    symbol: 'SESH',
    decimals: 9,
    name: 'Session Token',
    icon: 'https://stake.getsession.org/images/token_logo.svg'
  },
  asesh: {
    address: '0x10Ea9E5303670331Bdddfa66A4cEA47dae4fcF3b'
  },
  esesh: {
    address: '0x10Ea9E5303670331Bdddfa66A4cEA47dae4fcF3b'
  },
  eseshTest: {
    address: '0x0DBD22764C6C77827B4D03482998CA2dd61b5294'
  }
};

export default config;
